<template>
  <t-popup
    :placement="placement"
    overlayClassName="num-popover-container"
    v-model="popoverVisible"
    @visible-change="handleShow"
    trigger="click"
  >
    <template #content>
      <div style="padding: 0 4px 4px 4px">
        <div class="header">
          <div class="title">保存为用户组合</div>
          <div class="sub-title">人群维度筛选中使用</div>
        </div>
        <div class="body">
          <t-form ref="form" :data="form" :rules="rules" label-width="140px">
            <t-form-item label="人群维度显示名" name="name">
              <t-input v-model="form.name"></t-input>
            </t-form-item>
            <t-form-item label="人群维度描述" name="desc">
              <t-textarea :autosize="{ minRows: 2, maxRows: 5 }" v-model="form.desc"></t-textarea>
            </t-form-item>
          </t-form>
        </div>
        <div class="footer">
          <t-button theme="default" @click="handleClose">取 消</t-button>
          <t-button theme="primary" @click="handleOK" :loading="loading">确 定</t-button>
        </div>
      </div>
    </template>
    <slot></slot>
  </t-popup>
</template>

<script>
import { pollingPackageStatus } from '@/api/analysis/custom-analysis';
import SaveCrowdMessage from './save-crowd-message.vue';

class SaveCrowdPolling {
  constructor(vm, packageId) {
    this.vm = vm;
    this.packageId = packageId;
    this.status = 0;
    this.form = JSON.parse(JSON.stringify(vm.form)); // 深拷贝，因为可能继续新增人群，名称会变化
    this.timer = null;
    this.msgIns0 = null;
    this.msgIns1 = null;
    this.tmpIdx = 0;
  }

  start() {
    const h = this.vm.$createElement;
    this.msgIns0 = this.vm.$message({
      message: h(SaveCrowdMessage, {
        props: {
          status: this.status,
          packageId: this.packageId,
          packageName: this.form.name,
          callback: () => {
            this.msgIns0.close();
            this.msgIns0 = null;
          },
        },
      }),
      iconClass: '',
      customClass: 'save-crowd-message-container',
      showClose: false,
      duration: 0,
    });
    this.startPolling();
  }

  destroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.msgIns0) {
      this.msgIns0.close();
      this.msgIns0 = null;
    }
    if (this.msgIns1) {
      this.msgIns1.close();
      this.msgIns1 = null;
    }
  }

  showFinish() {
    if (this.msgIns0) {
      this.msgIns0.close();
      this.msgIns0 = null;
    }
    const h = this.vm.$createElement;
    this.msgIns1 = this.vm.$message({
      message: h(SaveCrowdMessage, {
        props: {
          status: this.status,
          packageId: this.packageId,
          packageName: this.form.name,
          callback: () => {
            this.msgIns1.close();
            this.msgIns1 = null;
          },
        },
      }),
      iconClass: '',
      customClass: 'save-crowd-message-container',
      showClose: false,
      duration: 0,
    });
    setTimeout(() => {
      if (this.msgIns1) {
        this.msgIns1.close();
        this.msgIns1 = null;
      }
    }, 5000);
  }

  async startPolling() {
    this.tmpIdx += 1;
    const retData = await pollingPackageStatus({ params: { id: this.packageId } });
    // if (this.tmpIdx > 5) {
    //   retData = true;
    // }
    if (retData === true) {
      this.status = 1;
      this.showFinish();
    } else {
      this.timer = setTimeout(() => {
        this.startPolling();
      }, 2000);
    }
  }
}

export default {
  props: {
    placement: {
      type: String,
      default: 'top',
    },
  },
  data() {
    return {
      loading: false,
      popoverVisible: false,
      form: {
        name: '',
        desc: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        desc: [
          { required: true, message: '请输入描述', trigger: 'blur' },
          { min: 1, max: 80, message: '长度在 1 到 80 个字符', trigger: 'blur' },
        ],
      },

      timer: null, // 轮询的timer
    };
  },
  methods: {
    handleClose() {
      this.popoverVisible = false;
    },

    handleShow() {},

    async handleOK() {
      const valid = await this.$refs.form.validate();
      if (valid === true) {
        this.loading = true;
        this.$emit('onConfirm', this.form, packageId => {
          this.popoverVisible = false; // 隐藏 popover
          const scp = new SaveCrowdPolling(this, packageId);
          scp.start();
          // const ins = this.$message({
          //   message: h(SaveCrowdMessage,
          //     {
          //       props: {
          //         packageId,
          //         packageName: this.form.name,
          //         callback: () => {
          //           ins.close();
          //         },
          //       },
          //     }),
          //   iconClass: '',
          //   customClass: 'save-crowd-message-container',
          //   showClose: true,
          //   duration: 0,
          // });
        });
        this.loading = false;
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.num-popover-container {
  .header {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dcdfe6;
    .title {
      font-weight: bold;
      font-size: 16px;
    }
    .sub-title {
      margin-left: 10px;
    }
  }
  .body {
    padding-top: 14px;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  }
}
</style>
